import script from "./groups.vue?vue&type=script&setup=true&lang=js"
export * from "./groups.vue?vue&type=script&setup=true&lang=js"

import "./groups.vue?vue&type=style&index=0&id=a36ed168&lang=scss&scoped=true"
import "./groups.vue?vue&type=style&index=1&id=a36ed168&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a36ed168"]])

export default __exports__